import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const API = axios.create({
  baseURL: BASE_URL,
});

// 🔐 Request Interceptor (Token attach karva mate)
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Get All Services
export const getAllServices = () => API.get("/api/service");
// Get Service By ID
export const getServiceById = (id) =>
  API.get(`/api/service/${id}`);
// Get Single Service by Slug
export const getServiceBySlug = (slug) =>
  API.get(`/api/service/${slug}`);
export const gethomebanner =() =>API.get("/api/hero")

// Get All Events
export const getAllEvents = () =>
  API.get("/api/events");

// Get Event By ID
export const getEventById = (id) =>
  API.get(`/api/events/${id}`);

// Get Event By Slug
export const getEventBySlug = (slug) =>
  API.get(`/api/events/slug/${slug}`);



// Get All Team Members
export const getAllTeamMembers = () =>
  API.get("/api/team/member");

// Get Single Team Member By ID
export const getTeamMemberById = (id) =>
  API.get(`/api/team/member/${id}`);

// Get Team Member By Slug
export const getTeamMemberBySlug = (slug) =>
  API.get(`/api/team/member/slug/${slug}`);

// ================= JOBS =================
export const getAllJobs = () =>
  API.get("/api/jobs");

export const getJobById = (id) =>
  API.get(`/api/jobs/${id}`);

export const getJobBySlug = (slug) =>
  API.get(`/api/jobs/slug/${slug}`);